<script>
import { BuildingComplexesService } from '@/services/building-complexes.service';
import BaseAutocompleteFilter from './BaseAutocompleteFilter';

export default {
  name: 'ConciergesFilter',

  extends: BaseAutocompleteFilter,

  methods: {
    getData() {
      BuildingComplexesService.getFilteredConcierges({
        search: this.search,
      }).then(({ data }) => {
        this.items = data;
      });
    },
  },
};
</script>
